module.exports = __webpack_public_path__ + "static/media/business_image.95c669db.png";